import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Facebook } from 'lucide-react';

export function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="bg-black text-white py-12 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-3xl mx-auto">
          {/* Support */}
          <div className="text-center md:text-left">
            <h4 className="font-mono text-xs uppercase tracking-widest mb-4 text-gray-400">
              {t('footer.support')}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/faq" className="font-body text-sm hover:text-[#0047AB] transition-colors" data-testid="footer-faq">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-body text-sm hover:text-[#0047AB] transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/cgv" className="font-body text-sm hover:text-[#0047AB] transition-colors" data-testid="footer-cgv">
                  {t('footer.cgv')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div className="text-center md:text-left">
            <h4 className="font-mono text-xs uppercase tracking-widest mb-4 text-gray-400">
              Réseaux sociaux
            </h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://www.instagram.com/belleville_machine/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="font-body text-sm hover:text-[#0047AB] transition-colors inline-flex items-center gap-2"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-4 h-4" />
                  Instagram
                </a>
              </li>
              <li>
                <a 
                  href="https://www.facebook.com/BellevilleMachine" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="font-body text-sm hover:text-[#0047AB] transition-colors inline-flex items-center gap-2"
                  data-testid="footer-facebook"
                >
                  <Facebook className="w-4 h-4" />
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center md:text-left">
            <h4 className="font-mono text-xs uppercase tracking-widest mb-4 text-gray-400">
              Contact
            </h4>
            <ul className="space-y-2 font-body text-sm text-gray-400">
              <li>
                <a href="mailto:bellevillemachine@gmail.com" className="hover:text-white transition-colors">
                  bellevillemachine@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:+33766702077" className="hover:text-white transition-colors">
                  07 66 70 20 77
                </a>
              </li>
              <li>
                <a href="https://www.bellevillemachine.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  www.bellevillemachine.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-6 text-center">
          <p className="font-mono text-xs text-gray-500 uppercase tracking-widest">
            © 2018 Belleville Machine / FOLGO SAS. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}
